import React from "react";
import styles from "./cashback.module.css";

import { Desktop, TabletAndBelow } from "../../components/mediaqueries";
import MainLayout from "../../layouts/main-layout/main-layout";
import { Footer } from "../../components";
const Cashback = () => {
  return (
    <>
      <MainLayout />
      <div style={{ width: "100%" }}>
        <Desktop>
          <div
            className={`${styles.section} ${styles.xlg} ${styles.block}`}
            style={{
              backgroundImage:
                "url(" +
                process.env.PUBLIC_URL +
                "/images/background-banner-rojo-mobile@3x.png" +
                ")",
            }}
          >
            <div
              className={`${styles.wrapper} ${styles.fluid} ${styles.xs} ${styles.block}`}
            >
              <div className={styles.wrapper_flex}>
                <div
                  className={`${styles.column_direction} ${styles.fluid} ${styles.wrapper_md}`}
                >
                  <h1 className={`${styles.h2_title}`}>¡Dinero de vuelta!</h1>
                  <span className={`${styles.h5_title} ${styles.__lighter_font}`}>
                    Descubre los beneficios de pagar <br /> con tu cuenta{" "}
                    <b>Claro Pay</b>
                  </span>
                </div>
                <div className={`${styles.wrapper_xs}`}>
                  <img
                    src={`${process.env.PUBLIC_URL}/images/cashback-consumer.png`}
                    alt=""
                    className={styles.cashback_banner}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* START SECTION */}
          <div style={{ margin: "1rem" }}>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <div style={{ width: "90%" }}>
                <div
                  className={`${styles.section} ${styles.xlg} ${styles.block} ${styles.rounded}`}
                  style={{
                    backgroundImage:
                      "url(" +
                      process.env.PUBLIC_URL +
                      "/images/background@3x.png" +
                      ")",
                  }}
                >
                  <div className={styles.section_container}>
                    <div className={`${styles.fluid} ${styles.column_direction}`}>
                      <div className={styles.sub_section_container_wrapper}>
                        <div className={styles.sub_section_container}>
                          <div
                            className={`${styles.sub_section_container} ${styles.__justify_flex_start} ${styles.column} ${styles.block}`}
                          >
                            <div
                              style={{
                                width: "65%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              <div
                                className={`${styles.sub_section} ${styles.block}`}
                              >
                                <div className={styles.wrapper}>
                                  <img
                                    src={`${process.env.PUBLIC_URL}/images/logo-telcel.svg`}
                                    alt="Telcel"
                                  />
                                </div>
                              </div>
                              <div
                                className={`${styles.sub_section} ${styles.block}`}
                              >
                                <div className={styles.wrapper}>
                                  <img
                                    src={`${process.env.PUBLIC_URL}/images/logo-telnor.svg`}
                                    alt="Telnor"
                                  />
                                </div>
                              </div>
                              <div
                                className={`${styles.sub_section} ${styles.block}`}
                              >
                                <div className={styles.wrapper}>
                                  <img
                                    src={`${process.env.PUBLIC_URL}/images/logo-telmex.svg`}
                                    alt="Telmex"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div style={{ display: "flex", flexDirection: "row" }}>
                            <div
                              className={`${styles.sub_section} ${styles.block}`}
                            >
                              <div className={styles.wrapper}>
                                <div className={styles.center_text}>
                                  <h2
                                    className={`${styles.h5_title} ${styles.center_text}`}
                                  >
                                    Recibe $20 de vuelta al pagar <br />
                                    tus facturas Telcel, Telmex <br />
                                    y Telnor con un monto <br /> mínimo de $200
                                  </h2>
                                </div>
                              </div>
                            </div>
                            <div
                              className={`${styles.sub_section} ${styles.block} ${styles.xlg}`}
                            >
                              <img
                                className={styles.yellow_banner_image}
                                src={`${process.env.PUBLIC_URL}/images/gr-fico-hombre@2x.png`}
                                alt="Telmex"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* END SECTION */}
          {/* START SECTION */}
          <div style={{ margin: "1rem" }}>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <div style={{ width: "90%" }}>
                <div
                  className={`${styles.section} ${styles.xlg} ${styles.block} ${styles.rounded}`}
                  style={{
                    backgroundImage:
                      "url(" +
                      process.env.PUBLIC_URL +
                      "/images/Background_blue@3x.png" +
                      ")",
                  }}
                >
                  <div className={styles.section_container}>
                    <div className={`${styles.fluid} ${styles.column_direction}`}>
                      <div className={styles.sub_section_container_wrapper}>
                        <div className={styles.sub_section_container}>
                          <div
                            className={`${styles.sub_section_container} ${styles.__justify_flex_start} ${styles.column} ${styles.block}`}
                          >
                            <div
                              style={{
                                width: "65%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              <div
                                className={`${styles.sub_section} ${styles.block}`}
                              >
                                <div className={styles.wrapper}>
                                  <img
                                    src={`${process.env.PUBLIC_URL}/images/logo-telcel.svg`}
                                    alt="Telcel"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div style={{ display: "flex", flexDirection: "row" }}>
                            <div
                              className={`${styles.sub_section} ${styles.block}`}
                            >
                              <div className={styles.wrapper}>
                                <div className={styles.center_text}>
                                  <h2
                                    className={`${styles.h5_title} ${styles.center_text}`}
                                  >
                                    Obtén el 5% de vuelta al <br />
                                    comprar un paquete o al <br />
                                    hacer una recarga de <br />
                                    Tiempo Aire Telcel
                                  </h2>
                                </div>
                              </div>
                            </div>
                            <div
                              className={`${styles.sub_section} ${styles.block} ${styles.xlg}`}
                            >
                              <img
                                className={styles.yellow_banner_image}
                                src={`${process.env.PUBLIC_URL}/images/gr-fico-mujer@3x.png`}
                                alt="Telmex"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* END SECTION */}
        </Desktop>
        <TabletAndBelow>
          <div
            className={`${styles.section} ${styles.xs} ${styles.block}`}
            style={{
              backgroundImage:
                "url(" +
                process.env.PUBLIC_URL +
                "/images/background-banner-rojo-mobile@3x.png" +
                ")",
            }}
          >
            <div className={`${styles.wrapper} ${styles.xs} ${styles.block}`}>
              <h1 className={`${styles.h2_title}`}>¡Dinero de vuelta!</h1>
              <span className={`${styles.h5_title} ${styles.__lighter_font}`}>
                Descubre los beneficios de <br /> pagar con tu cuenta{" "}
                <b>Claro Pay</b>
              </span>
            </div>
          </div>
          {/* SECTION */}
          <div style={{ margin: "1rem" }}>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <div style={{ maxWidth: "95%" }}>
                <div
                  className={`${styles.section} ${styles.xlg} ${styles.block} ${styles.rounded}`}
                  style={{
                    backgroundImage:
                      "url(" +
                      process.env.PUBLIC_URL +
                      "/images/background@3x.png" +
                      ")",
                  }}
                >
                  <div className={`${styles.fluid} ${styles.column_direction}`}>
                    <div
                      className={`${styles.sub_section_container} ${styles.column} ${styles.block}`}
                    >
                      <div
                        className={`${styles.sub_section} ${styles.__justify_center} ${styles.block}`}
                      >
                        <div className={styles.wrapper}>
                          <img
                            src={`${process.env.PUBLIC_URL}/images/logo-telcel.svg`}
                            alt="Telcel"
                          />
                        </div>
                      </div>
                      <div
                        className={`${styles.sub_section} ${styles.__justify_center} ${styles.block}`}
                      >
                        <div className={styles.wrapper}>
                          <img
                            src={`${process.env.PUBLIC_URL}/images/logo-telnor.svg`}
                            alt="Telnor"
                          />
                        </div>
                      </div>
                      <div
                        className={`${styles.sub_section} ${styles.__justify_center} ${styles.block}`}
                      >
                        <div className={styles.wrapper}>
                          <img
                            src={`${process.env.PUBLIC_URL}/images/logo-telmex.svg`}
                            alt="Telmex"
                          />
                        </div>
                      </div>
                    </div>
                    <div className={styles.sub_section_container_wrapper}>
                      <div className={styles.sub_section_container}>
                        <div
                          className={`${styles.sub_section} ${styles.__justify_center} ${styles.block}`}
                        >
                          <div className={styles.wrapper}>
                            <div className={styles.center_text}>
                              <h2
                                className={`${styles.h5_title} ${styles.center_text}`}
                              >
                                Recibe $20 de vuelta al pagar <br />
                                tus facturas Telcel, Telmex <br />
                                y Telnor con un monto <br /> mínimo de $200
                              </h2>
                            </div>
                          </div>
                        </div>
                        <div
                          className={`${styles.sub_section} ${styles.block} ${styles.xlg}`}
                        >
                          <img
                            className={styles.yellow_banner_image}
                            src={`${process.env.PUBLIC_URL}/images/gr-fico-hombre@3x.png`}
                            alt="Telmex"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* END SECTION */}

          {/* SECTION */}
          <div style={{ margin: "1rem" }}>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <div style={{ maxWidth: "95%" }}>
                <div
                  className={`${styles.section} ${styles.xlg} ${styles.block} ${styles.rounded}`}
                  style={{
                    backgroundImage:
                      "url(" +
                      process.env.PUBLIC_URL +
                      "/images/Background_blue@3x.png" +
                      ")",
                  }}
                >
                  <div className={`${styles.fluid} ${styles.column_direction}`}>
                    <div
                      className={`${styles.sub_section_container} ${styles.column} ${styles.block}`}
                    >
                      <div
                        className={`${styles.sub_section} ${styles.__justify_center} ${styles.block}`}
                      >
                        <div className={styles.wrapper}>
                          <img
                            src={`${process.env.PUBLIC_URL}/images/logo-telcel.svg`}
                            alt="Telcel"
                          />
                        </div>
                      </div>
                    </div>
                    <div className={styles.sub_section_container_wrapper}>
                      <div className={styles.sub_section_container}>
                        <div
                          className={`${styles.sub_section} ${styles.__justify_center} ${styles.block}`}
                        >
                          <div className={styles.wrapper}>
                            <div className={styles.center_text}>
                              <h2
                                className={`${styles.h5_title} ${styles.center_text}`}
                              >
                                Obtén el 5% de vuelta al <br /> comprar un paquete
                                o al <br />
                                hacer una recarga de <br /> Tiempo Aire Telcel
                              </h2>
                            </div>
                          </div>
                        </div>
                        <div
                          className={`${styles.sub_section} ${styles.block} ${styles.xlg}`}
                        >
                          <img
                            className={styles.yellow_banner_image}
                            src={`${process.env.PUBLIC_URL}/images/gr-fico-mujer@3x.png`}
                            alt="Telmex"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* END SECTION */}
        </TabletAndBelow>
      </div>
      <Footer />
    </>

  );
};

export default Cashback;
